import { EntityRepository, Repository } from "typeorm";
import { PackingBomLog } from "../packing-bom-log.entity";

@EntityRepository(PackingBomLog)
export class PackingBomLogRepository extends Repository<PackingBomLog>{


}
